module.exports = __webpack_public_path__ + "img/accessory_item_13.bc40ff74.svg";